/**
 * Lightweight symmetric obfuscation for ref numbers in the URL.
 * XOR cipher + base64url — keeps URLs opaque without adding dependencies.
 */

const KEY = 'cx7!pK2#mN9vR4zQ';

function xor(str) {
  return Array.from(str)
    .map((ch, i) => String.fromCharCode(ch.charCodeAt(0) ^ KEY.charCodeAt(i % KEY.length)))
    .join('');
}

export function encodeRefNum(refNum) {
  const obfuscated = xor(refNum);
  return btoa(obfuscated).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function decodeRefNum(token) {
  try {
    const padded = token.replace(/-/g, '+').replace(/_/g, '/');
    const aligned = padded + '=='.slice(0, (4 - (padded.length % 4)) % 4);
    return xor(atob(aligned));
  } catch {
    // If decoding fails (e.g. plain legacy URL), return the token as-is
    return token;
  }
}
